<template>
    <div class="navigation vertical-container vertical-container--in-secondary-side">
        <div class="vertical-container__header">
            <div class="navigation-title">Zákazníci</div>
        </div>

        <div class="vertical-container__content">
            <ul class="navigation-list">
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-customer-interest'}" class="navigation-list__link">
                        Zájemci
                    </router-link>
                </li>
                <li class="navigation-list__item">
                    <router-link :to="{ name: 'project-customer-newsletter'}" class="navigation-list__link">
                        Newsletter
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectCustomerNav',
}
</script>
